export default __webpack_public_path__ + "static/media/grocery5.9f091628.jpeg";